import { useState } from "react";
import { Grid } from "@mui/material";
import MDBox from "components/MDBox";
import { useQuery } from "@tanstack/react-query";
import {
  FormTitle,
  DatePickerField,
  Text,
  SelectField,
  ReadOnlyTextField,
} from "ui-components/Form";
import { useSKUOptions } from "hooks/useQueryHook";
import { getPackTypeUOM } from "services/data.internal.service";
import { getCOReturnCodeList } from "services/data.internal.service";

function CODetail({ detailRender, values, control, errors, setValue, getValues, mode = "ADD" }) {
  const { skuCode, customerCode, vendorCode } = values;
  const [status, newItem] = getValues(["status", "newItem"]);
  const [skuOptions, setSKUOptions] = useState([]);
  const [returnCodeOptions, setReturnCodeOptions] = useState([]);

  const onSKUChange = (e, option) => {
    setValue("coQty", 0);
    setValue("baseUOM", null);
    setValue("packType", null);
    setValue("skuCode", option.value);
  };

  useSKUOptions({
    customerCode,
    onSuccess: (data) =>
      setSKUOptions(data.data.data.map((x) => ({ label: x.skuCode, value: x.skuCode }))),
  });

  useQuery({
    queryKey: ["co-return-code-list"],
    queryFn: () => getCOReturnCodeList({ active: true }),
    refetchOnWindowFocus: false,
    onSuccess: (data) => {
      const options = data.data.data.map((x) => {
        return { label: `${x.returnCode}` + (x.description1 ? ` - ${x.description1}` : ``), value: x.returnCode };
      });
      setReturnCodeOptions(options);
    },
  })
  const onReturnCodeChange = (e, option) => {
    setValue("returnCode", option.value)
  }

  useQuery({
    queryKey: ["pack-type-uom", { skuCode, customerCode, vendorCode }],
    queryFn: () => getPackTypeUOM({ skuCode, customerCode, vendorCode }),
    enabled: Boolean(skuCode && customerCode && vendorCode && status === "Open"),
    onSuccess: (data) => {
      const { packType, baseUOM } = data.data.data;
      setValue("packType", packType);
      setValue("baseUOM", baseUOM);
    },
  });

  function renderFn(property, index, length) {
    const { size, disabled, editable, ...data } = property;
    const xs = 6 / 2;
    const fieldProps = {
      ...data,
      control,
      errors,
      ...(disabled && { disabled }),
      ...(mode === "EDIT" &&
        newItem === false &&
        editable === false && { disabled: true, type: "text" }),
      //...(mode === "EDIT" && values.status === "Cancel" && { disabled: true }),
      ...(mode === "EDIT" && status !== "Open" && { disabled: true, type: "readonly" }),
      //...(data.name==="coQty"&&{onChange:onQtyChange})
    };
    let renderField;
    switch (fieldProps.type) {
      case "text":
      case "number":
        renderField = <Text field={fieldProps} />;
        break;
      case "readonly":
        renderField = <ReadOnlyTextField field={fieldProps} />;
        break;
      case "select":
        let options = [];
        let onChange = null;
        switch (data.name) {
          case "skuCode":
            options = skuOptions;
            onChange = onSKUChange;
            break;
          case "returnCode":
            options = returnCodeOptions;
            onChange = onReturnCodeChange;
            break;
        }
        renderField = <SelectField field={fieldProps} options={options} onChange={onChange} />;
        break;
      case "date":
        renderField = <DatePickerField field={fieldProps} />;
        break;
    }
    return (
      <Grid key={index} item xs={xs}>
        {renderField}
      </Grid>
    );
  }
  return (
    <MDBox>
      <FormTitle title={mode === "EDIT" ? "Edit CO Detail" : "Add CO Detail"} />
      <MDBox mt={1.625}>
        {detailRender.map((rows, i) => (
          <Grid container spacing={3} key={i}>
            {rows.map((row, index) => renderFn(row, index, rows.length))}
          </Grid>
        ))}
      </MDBox>
    </MDBox>
  );
}

export default CODetail;
